import { Component, OnInit } from '@angular/core';

import { DialogRef, ModalComponent, CloseGuard } from 'ngx-modialog-11';
import { BSModalContext } from 'ngx-modialog-11/plugins/bootstrap';

import { FieldFormTypeEnum } from '../../common/enum/field-form-type.enum';

export class FormsContext extends BSModalContext {
  title: string;
  description: string;

  fields: any[];
  buttons: Object[];
  buttonsClass: string;

  onClose: Function;
  isClose: boolean;
  classes: string;

  status: boolean;
  svg: any;
  xlinkHref: string;
}

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
})
export class FormsComponent implements OnInit, CloseGuard, ModalComponent<FormsContext> {
  isValidate = false;
  context: FormsContext;

  wrongAnswer: boolean;

  fieldTypes;

  constructor(public dialog: DialogRef<FormsContext>) {
    this.context = dialog.context;
    this.wrongAnswer = true;
    dialog.setCloseGuard(this);
  }

  ngOnInit() {
    this.fieldTypes = FieldFormTypeEnum;
  }

  onClick(button) {
    if (!button) {
      return;
    }

    if (button.type === 'cancel') {
      this.close();
    }

    this.isValidate = this.validate();

    if (!this.isValidate) {
      return;
    }

    if (button.callback) {
      button.callback(this.context.fields);
    }

    this.close();
  }

  onClose() {
    this.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return this.wrongAnswer;
  }

  enter(field, value) {
    field.value = value;
    this.isValidate = this.validate();
  }

  private close() {
    this.wrongAnswer = false;
    this.dialog.close();

    if (this.context.onClose) {
      this.context.onClose();
    }
  }

  private validate() {
    if (!this.context.fields) {
      return false;
    }

    for (let i = 0; i < this.context.fields.length; i++) {
      if (this.context.fields[i].isRequired && !this.context.fields[i].value) {
        return false;
      }
    }

    return true;
  }
}
